import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationGroupData } from '@app/interfaces/rm/resource-instances';
import { SelectOption } from '@app/interfaces/sys/dict';
import { LocationFloorService } from '@services/rm/location-floor.service';
import { LocationLabService } from '@services/rm/location-lab.service';
import { LocationRoomService } from '@services/rm/location-room.service';
import { CacheService } from '@services/sys/cache.service';

@Component({
    selector: 'app-location-selects',
    templateUrl: './location-selects.component.html',
    styleUrls: ['./location-selects.component.less'],
})
export class LocationSelectsComponent implements OnInit {
    @Input() showLabel = false;
    @Output() getLocation  = new EventEmitter();
    selectLab!: number | undefined;
    selectFloor!: number | undefined;
    selectRoom!: number | undefined;
    selectFloorLoading = false;
    selectRoomLoading = false;
    labOptions: SelectOption[] = [];
    floorOptions: SelectOption[] = [];
    roomOptions: SelectOption[] = [];
    lastLocationData: LocationGroupData = {} as LocationGroupData;
    loading = false;

    constructor(private labService: LocationLabService,
                private floorService: LocationFloorService,
                private roomService: LocationRoomService,
                private cacheSrv: CacheService) {
    }

    async ngOnInit(): Promise<void> {
        try {
            this.loading = true;
            this.lastLocationData = this.showLabel ? this.cacheSrv.getNone('location') || {} : {};
            if (Object.keys(this.lastLocationData).length > 0) {
                const { locationLabId, locationFloorId, locationRoomId } = this.lastLocationData;
                await this.fetchLabOptions(true);
                const labItem = this.labOptions.find((item) => item.value === locationLabId);
                await this.fetchFloorOptions(true, !!labItem);
                const floorItem = this.floorOptions.find((floor) => floor.value === locationFloorId);
                await this.fetchRoomOptions(true, !!labItem, !!floorItem);
                const roomItem = this.roomOptions.find((room) => room.value === locationRoomId);
                this.selectLab = !!labItem ? locationLabId : undefined;
                this.selectFloor = !!floorItem ? locationFloorId : undefined;
                this.selectRoom = !!roomItem ? locationRoomId : undefined;
                this.emitData();
            } else {
                await this.fetchLabOptions();
            }
        } finally {
            this.loading = false;
        }
    }

    async fetchLabOptions(isStorage: boolean = false): Promise<void> {
        this.labOptions = await this.labService.options();
        if (isStorage) {
            return ;
        }
        this.selectLab = this.labOptions && this.labOptions.length > 0 ? this.labOptions[0].value as number : undefined;
        await this.fetchFloorOptions();
    }

    async fetchFloorOptions(isStorage: boolean = false, hasLab?: boolean): Promise<void> {
        try {
            const { locationLabId } = this.lastLocationData;
            this.selectFloorLoading = true;
            const labId = !isStorage ? this.selectLab : (hasLab ? locationLabId : undefined);
            // this.floorOptions = labId ? await this.floorService.options({ locationLabId: labId }) : await this.floorService.options();
            this.floorOptions = labId ? await this.floorService.options({ locationLabId: labId }) : [];
            if (isStorage) {
                return ;
            }
            this.selectFloor = this.selectLab && this.floorOptions && this.floorOptions.length > 0 ? this.floorOptions[0].value as number : undefined;
            await this.fetchRoomOptions();
        } finally {
            this.selectFloorLoading = false;
        }
    }

    async fetchRoomOptions(isStorage: boolean = false, hasLab?: boolean, hasFloor?: boolean): Promise<void> {
        try {
            this.selectRoomLoading = true;
            const { locationLabId, locationFloorId } = this.lastLocationData;
            let params: any = {};
            const labId = !isStorage ? this.selectLab : (hasLab ? locationLabId : undefined);
            const floorId = !isStorage ? this.selectFloor : (hasFloor ? locationFloorId : undefined);
            if (labId) {
                params = {...params, locationLabId: labId };
            }
            if (floorId) {
                params = {...params, locationFloorId: floorId };
            }
            // this.roomOptions = Object.keys(params).length > 0 ? await this.roomService.options(params) : await this.roomService.options();
            this.roomOptions = labId && floorId ? await this.roomService.options(params) : [];
            if (isStorage) {
                return ;
            }
            this.selectRoom = this.selectLab && this.selectFloor && this.roomOptions && this.roomOptions.length > 0 ? this.roomOptions[0].value as number : undefined;
            this.emitData();
        } finally {
            this.selectRoomLoading = false;
        }
    }

    async changeLab(): Promise<void> {
        await this.fetchFloorOptions();
    }

    async changeFloor(): Promise<void> {
        await this.fetchRoomOptions();
    }

    emitData(): void {
        const data = {
            locationLabId: this.selectLab,
            locationFloorId: this.selectFloor,
            locationRoomId: this.selectRoom
        };
        this.cacheSrv.set('location', data);
        this.getLocation.emit(data);
    }

    async changRoom(): Promise<void> {
        this.emitData();
    }
}


